import { Keuzehulp } from '../keuzehulpen'

const opvliegers: Keuzehulp = {
  title: 'Opvliegers',
  basePath: '/opvliegers',
  documentTitle: 'Opvliegers',
  routes: [
    {
      path: '',
      routeId: 'P13-001',
      nextRouteId: 'P13-002',
      type: 'intro',
      title: 'Voordat je begint…',
      backButton:
        'https://www.thuisarts.nl/keuzehulp/welke-behandeling-voor-opvliegers-past-bij-jou',
      columns: [
        {
          title: 'Neem de tijd',
          description: 'Neem alle tijd die je nodig hebt om de keuzehulp in te vullen',
        },
        {
          title: '15 minuten',
          description: 'Zo lang zijn de meeste mensen bezig met deze keuzehulp',
        },
        {
          title: 'Zoek een rustige plek',
          description: 'Zodat je goed jouw aandacht erbij kunt houden',
        },
        {
          title: 'Bekijk je antwoorden',
          description:
            'Je antwoorden worden niet bewaard. De keuzehulp onthoudt niet waar je gebleven bent',
        },
      ],
    },
    {
      path: '/stap-1',
      routeIndex: '1',
      routeId: 'P13-002',
      nextRouteId: 'P13-003',
      type: 'chapter',
      title: 'Opvliegers in de overgang',
      subtitle: 'Stap 1',
      description: `
          <p>We leggen eerst uit wat opvliegers zijn. En waardoor ze komen.</p>`,
      image: {
        src: `${process.env.PUBLIC_URL}/img/opvliegers-stap-1.jpg`,
        alt: '',
      },
      button: 'Start de keuzehulp',
    },
    {
      path: '/stap-1/wat-zijn-opvliegers',
      routeId: 'P13-003',
      nextRouteId: 'P13-004',
      type: 'explanation',
      title: 'Wat zijn opvliegers',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>Als je tussen de 40 en 60 jaar bent, kom je in de overgang: de jaren rond je laatste ongesteldheid.</p>
          <p>In de overgang kun je het opeens heel warm krijgen en zweten. Meestal 3 tot 5 minuten. Dit is een opvlieger.</p>
          <p>Opvliegers zijn normaal: 8 van de 10 vrouwen hebben ze in de overgang. Je hoeft je er niet voor te schamen.</p>
        </div>
      `,
      button: 'Ga verder',
    },
    {
      path: '/stap-1/wat-kun-je-merken-van-opvliegers',
      routeId: 'P13-004',
      nextRouteId: 'P13-005',
      type: 'explanation',
      title: 'Wat kun je merken van een opvlieger?',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p style="margin-bottom: 0">Je kunt dit merken bij een opvlieger:</p>
          <ul>
            <li>Je krijgt het opeens heel warm.</li>
            <li>Als je een lichte huid hebt: Je gezicht, hals of borst wordt rood.</li>
            <li>Je gaat zweten.</li>
            <li>Je hart klopt sneller.</li>
            <li>Je hebt rillingen.</li>
          </ul>
          <p>Ook ’s nachts kun je er last van hebben. Bijvoorbeeld omdat je opeens veel zweet. Misschien slaap je daardoor vaak slecht. Je kunt je daardoor moe, somber, verdrietig of snel boos voelen.</p>

          <p>Overdag ben je misschien bang dat je op een onhandig moment een opvlieger krijgt. Je kunt je onzeker gaan voelen.</p>
        </div>
      `,
      videos: [
        {
          src: 'https://media.thuisarts.nl/de-overgang-opvliegers.mp4',
          soundSrc: 'https://media.thuisarts.nl/de-overgang-opvliegers.mp3',
          poster: 'https://media.thuisarts.nl/de-overgang-opvliegers.jpg',
          videoSize: '66mb',
          subtitles: [
            {
              default: true,
              kind: 'subtitles',
              srclang: 'nl',
              label: 'Dutch',
              src: 'https://media.thuisarts.nl/de-overgang-opvliegers.vtt',
              subtitleSize: '5kb',
            },
          ],
        },
      ],
      button: 'Ga verder',
    },
    {
      path: '/stap-1/hoeveel-opvliegers-hebben-de-meeste-vrouwen',
      routeId: 'P13-005',
      nextRouteId: 'P13-006',
      type: 'explanation',
      title: 'Hoeveel opvliegers hebben de meeste vrouwen?',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>Sommige vrouwen hebben een paar opvliegers per maand. Andere vrouwen hebben er een paar per uur.</p>
          <p>Het is niet te voorspellen hoe lang je last van de opvliegers gaat hebben. De ene vrouw heeft 3 jaar opvliegers, de ander 5 jaar, weer een ander 7 jaar.</p>
        </div>
      `,
      button: 'Ga verder',
    },
    {
      path: '/stap-1/waardoor-krijg-je-opvliegers',
      routeId: 'P13-006',
      nextRouteId: 'P13-007',
      type: 'explanation',
      title: 'Waardoor krijg je opvliegers?',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>Opvliegers komen door minder vrouwelijk hormoon. Dat hormoon heet oestrogeen.</p>

          <p>Je eierstokken maken vrouwelijk hormoon. In de overgang gaan ze steeds minder maken. Dat komt omdat je eicellen dan op zijn. Dat gebeurt als je tussen de 40 en 60 jaar bent. Je wordt voor het laatst ongesteld. En je kunt dan niet meer zwanger worden.</p>
        </div>
      `,
      button: 'Ga verder',
    },
    {
      path: '/stap-1/minder-vrouwelijk-hormoon-en-je-hersenen',
      routeId: 'P13-007',
      nextRouteId: 'P13-008',
      type: 'explanation',
      title: 'Minder vrouwelijk hormoon en je hersenen',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>Je lichaam moet wennen aan minder vrouwelijk hormoon. Het warmte-centrum van je hersenen ook. Dat deel van de hersenen regelt je temperatuur.</p>

          <p>Je lichaam krijgt soms opeens seintjes dat het te warm is, terwijl dat niet zo is. Je lichaam wil dan afkoelen. Hierdoor gaan de bloedvaten van je huid meer open staan. Dat geeft een warm gevoel, roodheid en zweten: een opvlieger.</p>

          <p>Tijdens een opvlieger kan je hart ook sneller gaan kloppen. Dit komt ook door minder vrouwelijk hormoon in het lichaam.</p>
        </div>
      `,
      button: 'Ga verder',
    },
    {
      path: '/stap-2',
      routeIndex: '2',
      routeId: 'P13-008',
      nextRouteId: 'P13-009',
      type: 'chapter',
      title: 'Welke behandelingen zijn er voor opvliegers?',
      subtitle: 'Stap 2',
      description: `
          <p>Opvliegers kunnen vervelend zijn. Er zijn verschillende behandelingen.</p>`,
      image: {
        src: `${process.env.PUBLIC_URL}/img/opvliegers-stap-2.jpg`,
        alt: '',
      },
      button: 'Ga verder',
    },
    {
      path: '/stap-2/vraag-1',
      routeId: 'P13-009',
      nextRouteId: 'P13-010',
      type: 'question',
      hideFromOverview: true,
      title: 'Waar wil je meer over weten?',
      questions: [
        {
          type: 'multiple',
          answers: [
            {
              title: 'Gezonder leven',
              showChapter: '2.2',
            },
            {
              title: 'Praten en oefeningen',
              showChapter: '2.3',
            },
            {
              title: 'Hormonen gebruiken',
              showChapter: '2.4',
            },
            {
              title: 'Pillen clonidine: alleen geschikt als je geen hormonen mag',
              showChapter: '2.5',
            },
            {
              title: 'Acupunctuur',
              showChapter: '2.6',
            },
            {
              title: 'Middelen die artsen niet aanraden',
              showChapter: '2.7',
            },
          ],
        },
      ],
      button: 'Ga verder',
    },
    {
      path: '/stap-2/gezonder-leven-bij-opvliegers',
      routeId: 'P13-010',
      routeIndex: '2.2',
      nextRouteId: 'P13-011',
      type: 'popupCards',
      title: 'Gezonder leven bij opvliegers',
      align: 'left',
      description: `
        <div>
          <p>Gezonder leven kan helpen bij opvliegers. Je voelt je vaak beter als je gezond leeft. Daardoor heb je minder last van de opvliegers.</p>

          <p>Bekijk de adviezen waar je meer over wilt weten:</p>
        </div>
      `,
      cards: [
        {
          cardTitle: 'Eet gezonder',
          readingTime: '2 minuten leestijd',
          image: {
            src: `${process.env.PUBLIC_URL}/img/opvliegers-stap-2_2_1_card.jpg`,
            alt: '',
          },
          modalContent: `
            <div>
              <p>Gezond eten zorgt dat je je fitter voelt. Het zorgt waarschijnlijk niet voor minder opvliegers.</p>

              <p>Krijg je opvliegers van warme dranken, zoals koffie of thee? Of van gekruid eten? Eet en drink dit dan niet.</p>

              <h2 style="margin-bottom: 0; font-size: 18px; line-height: 1.6;">Geen speciaal dieet</h2>
              <p style="margin-top: 0">Een speciaal dieet is niet nodig.</p>

              <h2 style="margin-bottom: 0; font-size: 18px; line-height: 1.6;">Geen middelen uit de winkel</h2>
              <p style="margin-top: 0">Er zijn allerlei middelen voor de overgang te koop: met kruiden, zoals zilverkaars. Of met fyto-oestrogenen. Artsen raden het gebruik van deze middelen af.</p>

              <p>Zilverkaars kan schade aan de lever geven. </br>
              Fyto-oestrogenen zijn stoffen van planten die lijken op vrouwelijke hormonen. Fyto-oestrogenen kunnen zorgen voor minder opvliegers. Het is niet zeker of ze veilig zijn of erge bijwerkingen geven. Dit is niet goed onderzocht.</p>
            </div>
          `,
          videos: [
            {
              src: 'https://media.thuisarts.nl/zvm-gezond-eten.mp4',
              soundSrc: 'https://media.thuisarts.nl/zvm-gezond-eten.mp3',
              poster: 'https://media.thuisarts.nl/zvm-gezond-eten.jpg',
              videoSize: '30mb',
              subtitles: [
                {
                  default: true,
                  kind: 'subtitles',
                  srclang: 'nl',
                  label: 'Dutch',
                  src: 'https://media.thuisarts.nl/zvm-gezond-eten.vtt',
                  subtitleSize: '5kb',
                },
              ],
            },
          ],
        },
        {
          cardTitle: 'Drink minder alcohol',
          readingTime: '3 minuten leestijd',
          image: {
            src: `${process.env.PUBLIC_URL}/img/opvliegers-stap-2_2_2_card.jpg`,
            alt: '',
          },
          modalContent: `
            <div>
              <p>Minder alcohol drinken kan zorgen voor minder opvliegers. Vooral 's nachts kun je merken dat je minder zweet.</p>

              <p>Minder alcohol kan ook zorgen voor minder hartkloppingen. Bij hartkloppingen voel je je hart ineens snel of hard kloppen in je borst.</p>
            </div>
          `,
        },
        {
          cardTitle: 'Zorg voor minder stress',
          readingTime: '1 minuut leestijd',
          image: {
            src: `${process.env.PUBLIC_URL}/img/opvliegers-stap-2_2_3_card.jpg`,
            alt: '',
          },
          modalContent: `
            <div>
              <p>Met minder stress voel je je beter. Zo maak je stress minder:</p>
              <ul>
                <li>Probeer meer te ontspannen. </br> Dit kan door oefeningen te doen. </br> En je ontspant door elke dag iets te doen wat je leuk vindt. Bijvoorbeeld in de tuin werken of wandelen.</li>
                <li>Mindfulness oefeningen kunnen ook helpen. Bij mindfulness probeer je vooral aandacht te hebben voor wat je op dat moment doet. Dat kun je leren met oefeningen.</li>
                <li>Bedenk wat bij jou spanning geeft. En wat jou energie geeft. Praat erover met iemand die je vertrouwt. Je kunt het ook opschrijven.</li>
                <li>Zorg goed voor jezelf: beweeg veel, eet gezond en slaap genoeg.</li>
              </ul>
            </div>
          `,
          videos: [
            {
              src: 'https://media.thuisarts.nl/zvm-minder-stress.mp4',
              soundSrc: 'https://media.thuisarts.nl/zvm-minder-stress.mp3',
              poster: 'https://media.thuisarts.nl/zvm-minder-stress.jpg',
              videoSize: '25mb',
              subtitles: [
                {
                  default: true,
                  kind: 'subtitles',
                  srclang: 'nl',
                  label: 'Dutch',
                  src: 'https://media.thuisarts.nl/zvm-minder-stress.vtt',
                  subtitleSize: '3kb',
                },
              ],
            },
          ],
        },
        {
          cardTitle: 'Beweeg meer',
          readingTime: '2 minuten leestijd',
          image: {
            src: `${process.env.PUBLIC_URL}/img/opvliegers-stap-2_2_4_card.jpg`,
            alt: '',
          },
          modalContent: `
            <div>
              <p>Veel bewegen en sporten maakt stress minder. Het helpt om je minder zorgen te maken. Je voelt je positiever en fitter. Daardoor kun je minder last hebben van de opvliegers.</p>
              <ul>
                <li>Beweeg minimaal 2,5 uur per week actief. Bijvoorbeeld wandelen, fietsen, hardlopen, voetballen, fitness, dansen of een vechtsport.</li>
                <li>Maak ook je spieren en botten sterker met oefeningen of krachttraining.</li>
                <li>Zorg dat je niet te lang stil zit. Zit je overdag veel, bijvoorbeeld voor je werk? Sta dan regelmatig even op en loop een stukje.</li>
              </ul>
            </div>
          `,
          videos: [
            {
              src: 'https://media.thuisarts.nl/zvm-meer-bewegen.mp4',
              soundSrc: 'https://media.thuisarts.nl/zvm-meer-bewegen.mp3',
              poster: 'https://media.thuisarts.nl/zvm-meer-bewegen.jpg',
              videoSize: '24mb',
              subtitles: [
                {
                  default: true,
                  kind: 'subtitles',
                  srclang: 'nl',
                  label: 'Dutch',
                  src: 'https://media.thuisarts.nl/zvm-meer-bewegen.vtt',
                  subtitleSize: '4kb',
                },
              ],
            },
          ],
        },
        {
          cardTitle: 'Stoppen met roken',
          readingTime: '2 minuten leestijd',
          image: {
            src: `${process.env.PUBLIC_URL}/img/opvliegers-stap-2_2_5_card.jpg`,
            alt: '',
          },
          modalContent: `
            <div>
              <p>Roken kan zorgen voor meer opvliegers. Het zou dus kunnen helpen om te stoppen. Maar het is niet zeker dat je dan ook minder opvliegers krijgt.</p>

              <p>Stoppen met roken is natuurlijk wel goed voor je gezondheid. Je kunt hulp krijgen van je huisarts, de praktijkondersteuner of een coach.</p>
            </div>
          `,
          videos: [
            {
              src: 'https://media.thuisarts.nl/stoppen-met-roken.mp4',
              soundSrc: 'https://media.thuisarts.nl/stoppen-met-roken.mp3',
              poster: 'https://media.thuisarts.nl/stoppen-met-roken.jpg',
              videoSize: '30mb',
              subtitles: [
                {
                  default: true,
                  kind: 'subtitles',
                  srclang: 'nl',
                  label: 'Dutch',
                  src: 'https://media.thuisarts.nl/stoppen-met-roken.vtt',
                  subtitleSize: '4kb',
                },
              ],
            },
          ],
        },
        {
          cardTitle: 'Omgaan met zweten',
          readingTime: '1 minuut leestijd',
          image: {
            src: `${process.env.PUBLIC_URL}/img/opvliegers-stap-2_2_6_card.jpg`,
            alt: '',
          },
          modalContent: `
            <div>
              <p>Ook 's nachts kun je opvliegers hebben met veel zweten.</p>

              <ul>
                <li>Drink je alcohol? Als je minder of geen alcohol drinkt, kun je ook minder opvliegers hebben.</li>
              </ul>

              <p>Verder kun je met deze adviezen minder last hebben van zweten:</p>

              <ul>
                <li>Draag kleren van katoen, zijde of wol. Daar kan het zweet makkelijk ingaan. Het zweet kan dan verdampen.</li>
                <li>Draag een paar dunne lagen kleren over elkaar. Dan kun je makkelijk iets uitdoen.</li>
                <li>Slaap onder katoenen lakens of wollen dekens.</li>
                <li>Misschien ben je onzeker door de opvliegers en het vele zweten. Erover praten kan helpen. Bijvoorbeeld met een vriendin of collega.</li>
              </ul>

              <img src=${process.env.PUBLIC_URL}/img/opvliegers-stap-2_2_6.jpg alt="" />

            </div>
          `,
        },
        {
          cardTitle: 'Tips om beter te slapen',
          readingTime: '1 minuut leestijd',
          image: {
            src: `${process.env.PUBLIC_URL}/img/opvliegers-stap-2_2_7_card.jpg`,
            alt: '',
          },
          modalContent: `
            <div>
              <ul>
                <li>Sport of beweeg overdag of vroeg in de avond.</li>
                <li>Drink 's avonds geen koffie of andere drank met cafeïne.</li>
                <li>Drink geen alcohol.</li>
                <li>Kijk minimaal 1 uur voordat je gaat slapen niet meer naar je telefoon, tablet of computer. Zet een half uur voor het slapen de tv uit.</li>
                <li>Probeer een half uur voordat je gaat slapen te ontspannen. Doe bijvoorbeeld oefeningen om te ontspannen. Een massage of seks kan ook fijn zijn.</li>
                <li>Slaap onder katoenen lakens of wollen dekens.</li>
                <li>Sta steeds rond dezelfde tijd op en ga rond dezelfde tijd naar bed.</li>
                <li>Maak je je vaak zorgen? Praat over je zorgen en problemen met iemand die je vertrouwt.</li>
              </ul>
            </div>
          `,
        },
      ],
      button: 'Klaar met lezen, naar de volgende stap',
    },
    {
      path: '/stap-2/praten-en-oefeningen',
      routeIndex: '2.3',
      routeId: 'P13-011',
      nextRouteId: 'P13-012',
      type: 'explanation',
      align: 'left',
      titleAlign: 'center',
      title: 'Praten en oefeningen',
      subtitle: 'Stap 2',
      description: `
        <div>
          <p>Praten over je klachten en oefeningen kunnen helpen bij opvliegers. Dit kan met mindfulness of gedragstherapie.</p>

          <p>Deze behandeling kun je doen bij de praktijkondersteuner van de huisarts of bij een psycholoog. Je bespreekt je klachten en je krijgt oefeningen.</p>

          <p>Waarschijnlijk maakt de behandeling stress minder. Ook leer je om gedachtes te veranderen. Je hebt nu misschien gedachtes die niet helpen. Je leert om die te veranderen in gedachtes die jou wel helpen.</p>

          <p>Deze behandeling kan zorgen voor een paar opvliegers minder per dag. Er zijn geen nadelen of risico's.</p>
        </div>
      `,
      image: {
        src: `${process.env.PUBLIC_URL}/img/opvliegers-stap-2_3.jpg`,
        alt: '',
      },
      button: 'Klaar met lezen, naar de volgende stap',
    },
    {
      path: '/stap-2/behandeling-met-hormonen',
      routeId: 'P13-012',
      nextRouteId: 'P13-013',
      routeIndex: '2.4',
      type: 'explanation',
      title: 'Behandeling met hormonen',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>In de overgang gaat je lichaam minder vrouwelijk hormoon maken.</p>

          <p>Je kunt met pillen of hormonen op je huid zorgen dat dit hormoon toch in je lichaam komt. Hierdoor krijg je minder opvliegers.</p>

        </div>
      `,
      image: {
        src: `${process.env.PUBLIC_URL}/img/opvliegers-stap-2_4.jpg`,
        alt: '',
      },
      button: 'Klaar met lezen, naar de volgende stap',
    },
    {
      path: '/stap-2/hoeveel-minder-opvliegers-kun-je-verwachten',
      routeId: 'P13-013',
      nextRouteId: 'P13-014',
      type: 'explanation',
      title: 'Hoeveel minder opvliegers kun je verwachten met hormonen?',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>Hormonen zorgen ervoor dat je veel minder opvliegers krijgt. Bijvoorbeeld: vrouwen die er 10 per dag hadden, hebben er met hormonen nog ongeveer 2 per dag.</p>

          <p>Na 2 tot 3 weken kun je merken dat de hormonen gaan helpen. Soms duurt het langer voor de hormonen goed werken, bijvoorbeeld 2 of 3 maanden.</p>

        </div>
      `,
      button: 'Klaar met lezen, naar de volgende stap',
    },
    {
      path: '/stap-2/welke-hormomen-helpen-tegen-opvliegers',
      routeId: 'P13-014',
      nextRouteId: 'P13-015',
      type: 'explanation',
      title: 'Welke hormonen helpen tegen opvliegers?',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>Het hormoon dat helpt tegen opvliegers heet estradiol. Estradiol zit in pillen, een pleister, een gel of spray.</p>

          <p>Estradiol geeft iets meer kans op baarmoederkanker. </br>
          Daarom krijg je er een hormoon bij dat daartegen beschermt: een progestageen. Een progestageen zit in pillen en in de hormoonspiraal.</p>

          <p>Er zijn ook pillen waar beide hormonen inzitten.</p>

        </div>
      `,
      button: 'Klaar met lezen, naar de volgende stap',
    },
    {
      path: '/stap-2/wanneer-mag-je-geen-hormonen-gebruiken',
      routeId: 'P13-015',
      nextRouteId: 'P13-016',
      type: 'explanation',
      title: 'Wanneer mag je geen hormonen gebruiken?',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>In deze situaties mag je geen hormonen:</p>

          <ul>
            <li>Je hebt kanker die groeit door hormonen, zoals borstkanker of baarmoederkanker. Of je hebt dit gehad.</li>
            <li>Je hebt trombose of longembolie. Of je hebt dit gehad. Als je bloedverdunners gebruikt, kun je wel hormonen gebruiken.</li>
            <li>Je hebt een hartaanval gehad.</li>
            <li>Je hebt een beroerte gehad.</li>
            <li>Er komt af en toe bloed uit je vagina en het is niet duidelijk waardoor dat komt.</li>
            <li>Je hebt een leverziekte.</li>
            <li>Je rookt.</li>
          </ul>

        </div>
      `,
      button: 'Klaar met lezen, naar de volgende stap',
    },
    {
      path: '/stap-2/vraag-2',
      routeId: 'P13-016',
      nextRouteId: 'P13-017',
      subtitle: 'Maak een keuze',
      title: 'Klik op jouw situatie om te zien wat jij kunt gebruiken',
      type: 'uniqueQuestion',
      hideFromOverview: true,
      answers: [
        {
          title: 'Je wordt nog ongesteld en wilt een voorbehoedmiddel',
          nextRouteId: 'P13-017',
        },
        {
          title: 'Je wordt nog ongesteld en wilt geen voorbehoedmiddel',
          nextRouteId: 'P13-018',
        },
        {
          title: 'Je wordt al een jaar bijna niet meer ongesteld',
          nextRouteId: 'P13-019',
        },
        {
          title: 'Je hebt geen baarmoeder meer',
          nextRouteId: 'P13-020',
        },
        {
          title: 'Je hebt endometriose en je hebt geen baarmoeder meer',
          nextRouteId: 'P13-021',
        },
      ],
    },
    {
      path: '/stap-2/vraag-3',
      routeId: 'P13-017',
      nextRouteId: 'P13-022',
      type: 'question',
      hideFromOverview: true,
      title: 'Je wordt nog ongesteld en wilt een voorbehoedmiddel',
      subtitle: 'Je kan 1 antwoord kiezen',
      questions: [
        {
          type: 'single',
          answers: [
            {
              title: '2 keer per week een hormoonpleister plakken',
            },
            {
              title: 'elke dag spray of gel op je huid doen',
            },
            {
              title: 'elke dag een pil met hormoon erin slikken',
            },
          ],
        },
      ],
      descriptionAlign: 'left',
      description: `
        <div>
          <p>Daarbij kun je als voorbehoedmiddel het beste een hormoonspiraal kiezen.</p>
        </div>
      `,
      modalLink: 'Lees meer over kiezen tussen pillen en pleisters, gel of spray',
      modalHeader: 'Hoe kies je tussen hormonen in pillen of in pleister, gel of spray?',
      modalText: `
        <div>
          <p>Hormonen in pillen, pleister, gel of spray werken even goed tegen opvliegers. Soms kun je misschien beter kiezen voor pleisters, een gel of spray. Bijvoorbeeld in deze situaties:</p>
          <ul>
            <li>Je bent te zwaar.</li>
            <li>Je hebt migraine.</li>
            <li>Je hebt meer kans op een ziekte van hart of bloedvaten. Bijvoorbeeld omdat je een hoge bloeddruk of een hoog cholesterol hebt.</li>
            <li>Je hebt vroeger tijdens een zwangerschap problemen gehad. Zoals een hoge bloeddruk, zwangerschaps-vergiftiging of suikerziekte (zwangerschapsdiabetes).</li>
            <li>In jouw familie hebben mensen deze ziektes: een hoge bloeddruk, een hoog cholesterol, ziektes van hart of bloedvaten of trombose. Trombose is een ziekte waarbij er bloedklonten vastzitten in een bloedvaten.</li>
          </ul>

          <p>In deze situaties geven pleisters, gel of spray misschien een kleinere kans op bijwerkingen.</p>
        </div>
      `,
      button: 'Ga verder',
    },
    {
      path: '/stap-2/vraag-4',
      routeId: 'P13-018',
      nextRouteId: 'P13-022',
      type: 'question',
      hideFromOverview: true,
      title: 'Je wordt nog ongesteld en wilt geen voorbehoedmiddel',
      subtitle: 'Je kan 1 antwoord kiezen',
      questions: [
        {
          type: 'single',
          answers: [
            {
              title:
                '2 keer per week een hormoonpleister en 1 keer per dag een pil, 14 dagen per maand',
            },
            {
              title:
                'elke dag gel of spray op je huid en 1 keer per dag een pil, 14 dagen per maand',
            },
            {
              title: '2 keer per week een hormoonpleister en een hormoonspiraal',
            },
            {
              title: 'elke dag gel of spray op je huid en een hormoonspiraal',
            },
            {
              title:
                '1 keer per dag 1 pil: 14 dagen per maand zitten er 2 hormonen in, de rest van de maand 1 hormoon',
            },
            {
              title: '1 keer per dag een pil met 1 hormoon erin en een hormoonspiraal',
            },
          ],
        },
      ],
      modalLink: 'Lees meer over kiezen tussen pillen en pleisters, gel of spray',
      modalHeader: 'Hoe kies je tussen hormonen in pillen of in pleister, gel of spray?',
      modalText: `
        <div>
          <p>Hormonen in pillen, pleister, gel of spray werken even goed tegen opvliegers. Soms kun je misschien beter kiezen voor pleisters, een gel of spray. Bijvoorbeeld in deze situaties:</p>
          <ul>
            <li>Je bent te zwaar.</li>
            <li>Je hebt migraine.</li>
            <li>Je hebt meer kans op een ziekte van hart of bloedvaten. Bijvoorbeeld omdat je een hoge bloeddruk of een hoog cholesterol hebt.</li>
            <li>Je hebt vroeger tijdens een zwangerschap problemen gehad. Zoals een hoge bloeddruk, zwangerschaps-vergiftiging of suikerziekte (zwangerschapsdiabetes).</li>
            <li>In jouw familie hebben mensen deze ziektes: een hoge bloeddruk, een hoog cholesterol, ziektes van hart of bloedvaten of trombose. Trombose is een ziekte waarbij er bloedklonten vastzitten in een bloedvaten.</li>
          </ul>

          <p>In deze situaties geven pleisters, gel of spray misschien een kleinere kans op bijwerkingen.</p>
        </div>
      `,
      button: 'Ga verder',
    },
    {
      path: '/stap-2/vraag-5',
      routeId: 'P13-019',
      nextRouteId: 'P13-022',
      type: 'question',
      hideFromOverview: true,
      title: 'Je wordt al een jaar bijna niet meer ongesteld',
      subtitle: 'Je kan 1 antwoord kiezen',
      questions: [
        {
          type: 'single',
          answers: [
            {
              title: '2 keer per week een hormoonpleister en 1 keer per dag een pil',
            },
            {
              title: 'elke dag gel of spray op je huid doen en 1 keer per dag een pil',
            },
            {
              title: '1 keer per dag 1 pil met 2 hormonen',
            },
            {
              title: '1 keer per dag 2 pillen met 2 verschillende hormonen',
            },
          ],
        },
      ],
      modalLink: 'Lees meer over kiezen tussen pillen en pleisters, gel of spray',
      modalHeader: 'Hoe kies je tussen hormonen in pillen of in pleister, gel of spray?',
      modalText: `
        <div>
          <p>Hormonen in pillen, pleister, gel of spray werken even goed tegen opvliegers. Soms kun je misschien beter kiezen voor pleisters, een gel of spray. Bijvoorbeeld in deze situaties:</p>
          <ul>
            <li>Je bent te zwaar.</li>
            <li>Je hebt migraine.</li>
            <li>Je hebt meer kans op een ziekte van hart of bloedvaten. Bijvoorbeeld omdat je een hoge bloeddruk of een hoog cholesterol hebt.</li>
            <li>Je hebt vroeger tijdens een zwangerschap problemen gehad. Zoals een hoge bloeddruk, zwangerschaps-vergiftiging of suikerziekte (zwangerschapsdiabetes).</li>
            <li>In jouw familie hebben mensen deze ziektes: een hoge bloeddruk, een hoog cholesterol, ziektes van hart of bloedvaten of trombose. Trombose is een ziekte waarbij er bloedklonten vastzitten in een bloedvaten.</li>
          </ul>

          <p>In deze situaties geven pleisters, gel of spray misschien een kleinere kans op bijwerkingen.</p>
        </div>
      `,
      button: 'Ga verder',
    },
    {
      path: '/stap-2/vraag-6',
      routeId: 'P13-020',
      nextRouteId: 'P13-022',
      type: 'question',
      hideFromOverview: true,
      title: 'Je hebt geen baarmoeder meer',
      subtitle: 'Je kunt 1 antwoord kiezen.',
      questions: [
        {
          type: 'single',
          answers: [
            {
              title: 'elke dag 1 pil met alleen estradiol. Je hebt geen stopweek',
            },
            {
              title: '2 keer per week een hormoonpleister',
            },
            {
              title: 'elke dag gel of spray op je huid doen',
            },
          ],
        },
      ],
      descriptionAlign: 'left',
      description: `
        <div>
          <p>Je hebt alleen een middel met estradiol nodig.</p>
        </div>
      `,
      modalLink: 'Lees meer over kiezen tussen pillen en pleisters, gel of spray',
      modalHeader: 'Hoe kies je tussen hormonen in pillen of in pleister, gel of spray?',
      modalText: `
        <div>
          <p>Hormonen in pillen, pleister, gel of spray werken even goed tegen opvliegers. Soms kun je misschien beter kiezen voor pleisters, een gel of spray. Bijvoorbeeld in deze situaties:</p>
          <ul>
            <li>Je bent te zwaar.</li>
            <li>Je hebt migraine.</li>
            <li>Je hebt meer kans op een ziekte van hart of bloedvaten. Bijvoorbeeld omdat je een hoge bloeddruk of een hoog cholesterol hebt.</li>
            <li>Je hebt vroeger tijdens een zwangerschap problemen gehad. Zoals een hoge bloeddruk, zwangerschaps-vergiftiging of suikerziekte (zwangerschapsdiabetes).</li>
            <li>In jouw familie hebben mensen deze ziektes: een hoge bloeddruk, een hoog cholesterol, ziektes van hart of bloedvaten of trombose. Trombose is een ziekte waarbij er bloedklonten vastzitten in een bloedvaten.</li>
          </ul>

          <p>In deze situaties geven pleisters, gel of spray misschien een kleinere kans op bijwerkingen.</p>
        </div>
      `,
      button: 'Ga verder',
    },
    {
      path: '/stap-2/vraag-7',
      routeId: 'P13-021',
      nextRouteId: 'P13-022',
      type: 'question',
      hideFromOverview: true,
      title: 'Je hebt endometriose en geen baarmoeder',
      subtitle: 'Je kunt 1 antwoord kiezen.',
      questions: [
        {
          type: 'single',
          answers: [
            {
              title: '2 keer per week een hormoonpleister en 1 keer per dag een pil',
            },
            {
              title: 'elke dag gel of spray op je huid doen en 1 keer per dag een pil',
            },
            {
              title: '1 keer per dag 1 pil met 2 hormonen',
            },
            {
              title: '1 keer per dag 2 pillen met 2 verschillende hormonen',
            },
          ],
        },
      ],
      modalLink: 'Lees meer over kiezen tussen pillen en pleisters, gel of spray',
      modalHeader: 'Hoe kies je tussen hormonen in pillen of in pleister, gel of spray?',
      modalText: `
        <div>
          <p>Hormonen in pillen, pleister, gel of spray werken even goed tegen opvliegers. Soms kun je misschien beter kiezen voor pleisters, een gel of spray. Bijvoorbeeld in deze situaties:</p>
          <ul>
            <li>Je bent te zwaar.</li>
            <li>Je hebt migraine.</li>
            <li>Je hebt meer kans op een ziekte van hart of bloedvaten. Bijvoorbeeld omdat je een hoge bloeddruk of een hoog cholesterol hebt.</li>
            <li>Je hebt vroeger tijdens een zwangerschap problemen gehad. Zoals een hoge bloeddruk, zwangerschaps-vergiftiging of suikerziekte (zwangerschapsdiabetes).</li>
            <li>In jouw familie hebben mensen deze ziektes: een hoge bloeddruk, een hoog cholesterol, ziektes van hart of bloedvaten of trombose. Trombose is een ziekte waarbij er bloedklonten vastzitten in een bloedvaten.</li>
          </ul>

          <p>In deze situaties geven pleisters, gel of spray misschien een kleinere kans op bijwerkingen.</p>
        </div>
      `,
      button: 'Ga verder',
    },
    {
      path: '/stap-2/hoe-gebruik-je-homonen',
      routeId: 'P13-022',
      nextRouteId: 'P13-023',
      type: 'popupCards',
      title: 'Hoe gebruik je hormonen in de overgang?',
      align: 'left',
      description: `
        <div>
          <p>Bekijk de middelen die je wilt gebruiken</p>
        </div>
      `,
      button: 'Ga verder',
      cards: [
        {
          cardTitle: 'Pillen met hormonen als je nog ongesteld wordt',
          readingTime: '2 minuten leestijd',
          image: {
            src: `${process.env.PUBLIC_URL}/img/opvliegers-stap-2_4_4_1_card.jpg`,
            alt: '',
          },
          modalContent: `
            <div>
              <ul>
                <li>Je slikt eerst 2 weken pillen met alleen estradiol.</li>
                <li>Daarna slik je 2 weken pillen met estradiol en een progestageen. Deze pil heeft meestal een andere kleur. De 2 soorten pillen zitten in dezelfde strip.</li>
                <li>Je neemt elke dag 1 pil. Je hebt geen stopweek.</li>
              </ul>

              <img src=${process.env.PUBLIC_URL}/img/opvliegers-stap-2_4_4_1.jpg alt="" />

            </div>
          `,
        },
        {
          cardTitle: 'Pleister met hormonen',
          readingTime: '3 minuten leestijd',
          image: {
            src: `${process.env.PUBLIC_URL}/img/opvliegers-stap-2_4_4_2_card.jpg`,
            alt: '',
          },
          modalContent: `
            <div>
              <p>Je plakt 2 keer per week een pleister op je lichaam:</p>

              <ul>
                <li>Plak de pleister als het kan op je bil. Op je buik of rug kan ook. Plak de pleister niet op je borst. Het hormoon uit de pleister kan daar niet goed de huid in.</li>
                <li>Kies een stuk huid zonder wondjes of bultjes.</li>
                <li>Zorg dat dat stuk huid schoon en droog is.</li>
                <li>Smeer geen crème op die plek. Daardoor blijft de pleister minder goed zitten.</li>
              </ul>

              <p>Doe de pleister steeds op een andere plek. Laat een stuk huid minstens 2 weken rusten voor je er weer een pleister op doet.</p>

              <p>Je kunt gewoon in bad en onder de douche.</p>

              <p>Zorg ervoor dat de pleister niet in de zon komt. Zonlicht kan ervoor zorgen dat de pleister niet meer werkt.</p>

              <img src=${process.env.PUBLIC_URL}/img/opvliegers-stap-2_4_4_2.jpg alt="" />

            </div>
          `,
        },
        {
          cardTitle: 'Spray of gel met hormonen',
          readingTime: '1 minuut leestijd',
          image: {
            src: `${process.env.PUBLIC_URL}/img/opvliegers-stap-2_4_4_3_card.jpg`,
            alt: '',
          },
          modalContent: `
            <div>
              <ul>
                <li>Gel of spray smeer of spuit je elke dag aan de binnenkant van je arm of bovenbeen. Zorg dat die plek schoon en droog is.</li>
                <li>Laat de gel of spray op je huid goed drogen. Na 2 minuten is de gel of spray opgedroogd. Dan kun je kleding erover aantrekken.</li>
                <li>Wil je hierna douchen of in bad? Dan moet je minstens 1 uur wachten.</li>
                <li>Zorg ook dat jij of iemand anders de huid niet aanraakt binnen 1 uur. Gebeurt dit wel, bijvoorbeeld met een hand? Was dan die hand af met water en zeep.</li>
              </ul>
              <img src=${process.env.PUBLIC_URL}/img/opvliegers-stap-2_4_4_3.jpg alt="" />
            </div>
          `,
        },
        {
          cardTitle: 'Hormoonspiraal',
          readingTime: '2 minuten leestijd',
          image: {
            src: `${process.env.PUBLIC_URL}/img/opvliegers-stap-2_4_4_4_card.jpg`,
            alt: '',
          },
          modalContent: `
            <div>
              <p>Een arts kan een hormoonspiraal in je baarmoeder plaatsen. Die geeft een progestageen af. Dat beschermt tegen baarmoederkanker. En werkt als voorbehoedmiddel. De hormoonspiraal beschermt 3 jaar tegen baarmoederkanker.</p>

              <p>In deze film zie je hoe de arts het spiraaltje in je baarmoeder plaatst.</p>
            </div>
          `,
          videos: [
            {
              src: 'https://media.thuisarts.nl/een-spiraaltje-laten-plaatsen.mp4',
              soundSrc: 'https://media.thuisarts.nl/een-spiraaltje-laten-plaatsen.mp3',
              poster: 'https://media.thuisarts.nl/een-spiraaltje-laten-plaatsen.jpg',
              videoSize: '78mb',
              subtitles: [
                {
                  default: true,
                  kind: 'subtitles',
                  srclang: 'nl',
                  label: 'Dutch',
                  src: 'https://media.thuisarts.nl/een-spiraaltje-laten-plaatsen.vtt',
                  subtitleSize: '4kb',
                },
              ],
            },
          ],
        },
        {
          cardTitle: 'Pillen met hormonen als je al een jaar bijna niet ongesteld wordt',
          readingTime: '2 minuten leestijd',
          image: {
            src: `${process.env.PUBLIC_URL}/img/opvliegers-stap-2_4_4_5_card.jpg`,
            alt: '',
          },
          modalContent: `
            <div>
              <p>Je krijgt pillen waar 2 hormonen inzitten: estradiol en een progestageen. Alle pillen hebben dezelfde kleur.</p>

              <ul>
                <li>Je neemt elke dag 1 pil.</li>
                <li>Je hebt geen stopweek.</li>
              </ul>

              <img src=${process.env.PUBLIC_URL}/img/opvliegers-stap-2_4_4_1.jpg alt="" />
            </div>
          `,
        },
      ],
    },
    {
      path: '/stap-2/bijwerkingen-van-behandeling-met-hormonen',
      routeId: 'P13-023',
      nextRouteId: 'P13-024',
      type: 'explanation',
      title: 'Bijwerkingen van behandeling met hormonen',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>Hormonen kunnen bijwerkingen geven.</p>

          <p>In de eerste maanden houdt je lichaam soms meer vocht vast. Je kunt hierdoor deze klachten hebben:</p>

          <ul>
            <li>gevoelige borsten</li>
            <li>hoofdpijn</li>
            <li>misselijk zijn</li>
          </ul>

          <p>Ook kun je (weer) bloed verliezen.</p>
        </div>
      `,
      button: 'Klaar met lezen, naar de volgende stap',
    },
    {
      path: '/stap-2/geven-hormonen-grotere-kans-op-ziektes',
      routeId: 'P13-024',
      nextRouteId: 'P13-025',
      type: 'explanation',
      title: 'Geven hormonen een grotere kans op ziektes?',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>Je risico op ziektes hangt vooral af van %MODALLINK%</p>

          <p>Als je hormonen gebruikt, heb je een iets grotere kans op sommige ziektes. De kans blijft klein.</p>

          <ul>
            <li><strong>Kans op borstkanker</strong>: Een behandeling met estradiol en progestageen kan een iets grotere kans op borstkanker geven. Hoe groot deze kans is, verschilt per soort progestageen, hoe lang je het gebruikt en hoe oud je bent.</li>
            <li><strong>Kans op klonten in een bloedvat (trombose)</strong>: Middelen met estradiol geven een iets grotere kans op klonten bloed in een bloedvat. Bij pleisters, gel of spray is die kans waarschijnlijk kleiner dan bij pillen.</li>
            <li><strong>Kans op een beroerte</strong>: Je hebt een iets grotere kans op een beroerte als je een behandeling met estradiol krijgt. De kans blijft klein.</li>
            <li><strong>Kans op baarmoederkanker</strong>: Een behandeling met estradiol geeft een iets grotere kans op baarmoederkanker. Een progestageen maakt deze kans weer kleiner. Hoe klein deze kans wordt, verschilt per soort progestageen. De kans op baarmoederkanker blijft klein.</li>
          </ul>

          <p>Bespreek deze risico's met je arts.</p>
        </div>
      `,
      modalLink: 'hoe gezond je leeft.',
      modalHeader: 'Kans op ziektes kleiner maken als je hormonen gebruikt',
      modalText: `
        <div>
          <p>Hormonen gebruiken kan de kans op sommige ziektes dus soms iets groter maken. Maar jouw kans op ziektes hangt vooral af van hoe gezond je leeft.</p>

          <p>Dit kun je zelf doen om je kans op ziektes kleiner te maken:</p>

          <ul>
            <li>Probeer te stoppen met roken. Je kunt daar hulp bij krijgen. Dat maakt de kans groter dat het lukt.</li>
            <li>Drink minder of geen alcohol. Minder alcohol kan ook zorgen voor minder opvliegers.</li>
            <li><a href="https://www.thuisarts.nl/gezond-leven/ik-wil-gezond-bewegen" target="_blank">Beweeg meer.</a></li>
            <li><a href="https://www.thuisarts.nl/gezond-eten/ik-wil-gezond-eten" target="_blank">Eet gezond.</a></li>
            <li>Probeer af te vallen <a href="https://www.thuisarts.nl/overgewicht-bij-volwassenen" target="_blank">als je te zwaar bent.</a></li>
          </ul>
        </div>
      `,
      button: 'Klaar met lezen, naar de volgende stap',
    },
    {
      path: '/stap-2/pillen-clonidine-bij-opvliegers',
      routeId: 'P13-025',
      nextRouteId: 'P13-026',
      routeIndex: '2.5',
      type: 'explanation',
      title: 'Pillen clonidine bij opvliegers',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>Clonidine is een medicijn dat je bloeddruk lager maakt. Het geeft ongeveer 1 opvlieger minder per dag. </br>
          Dit medicijn is alleen geschikt als je geen hormonen mag krijgen.</p>

          <h2 style="margin-bottom: 0; font-size: 18px; line-height: 1.6;">Bijwerkingen</h2>
          <p style="margin-top: 0;">Het medicijn heeft namelijk veel bijwerkingen. Zoals slaapproblemen, angst, duizelig worden, droge mond, hoofdpijn, misselijk zijn en overgeven.
          In de eerste week dat je clonidine slikt, mag je niet autorijden.</p>

          <h2 style="margin-bottom: 0; font-size: 18px; line-height: 1.6;">4 weken proberen</h2>
          <p style="margin-top: 0;">Bespreek het met je huisarts als je dit medicijn wilt proberen.</br>
          Als je het probeert, slik je 2 pillen per dag. Helpt het na 4 weken niet? Dan kun je beter stoppen. Je slikt dan een paar dagen pillen met minder medicijn. Daarna stop je helemaal.</p>
        </div>
      `,
      button: 'Klaar met lezen, naar de volgende stap',
    },
    {
      path: '/stap-2/acupunctuur',
      routeId: 'P13-026',
      nextRouteId: 'P13-027',
      routeIndex: '2.6',
      type: 'explanation',
      title: 'Acupunctuur',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>Bij acupunctuur zet een acupuncturist naaldjes in je huid. Vaak zijn er meer behandelingen nodig: 4 of 5.</p>

          <p>Dit geeft misschien minder opvliegers. Maar zeker is dit niet.</p>

          <p>Waarschijnlijk heeft de behandeling geen nadelen of risico's.</p>
        </div>
      `,
      button: 'Klaar met lezen, naar de volgende stap',
    },
    {
      path: '/stap-2/middelen-die-artsen-niet-aanraden',
      routeId: 'P13-027',
      nextRouteId: 'P13-028',
      routeIndex: '2.7',
      type: 'explanation',
      title: 'Middelen die artsen niet aanraden',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>Er zijn allerlei middelen voor de overgang te koop: met kruiden, zoals zilverkaars. Of met fyto-oestrogenen. Artsen raden het gebruik van deze middelen af.</p>

          <p>Zilverkaars kan schade aan de lever geven. </br>
          Fyto-oestrogenen zijn stoffen van planten die lijken op vrouwelijke hormonen. Fyto-oestrogenen kunnen zorgen voor minder opvliegers. Het is niet zeker of ze veilig zijn of erge bijwerkingen geven. Dit is niet goed onderzocht.</p>
        </div>
      `,
      button: 'Klaar met lezen, naar de volgende stap',
    },
    {
      path: '/stap-3',
      routeIndex: '3',
      routeId: 'P13-028',
      nextRouteId: 'P13-029',
      type: 'chapter',
      title: 'Wat weet jij van opvliegers? En wat vind jij belangrijk?',
      subtitle: 'Stap 3',
      description: `
          <p>Je krijgt nu zinnen te zien. Bij elke zin kun je zeggen wat je ervan vindt. En wat je zelf wilt. Zo ontdek je wat voor jou belangrijk is bij de behandeling van opvliegers.</p>`,
      image: {
        src: `${process.env.PUBLIC_URL}/img/opvliegers-stap-3.jpg`,
        alt: '',
      },
      button: 'Ga verder',
    },
    {
      path: '/stap-3/vraag-1',
      routeId: 'P13-029',
      nextRouteId: 'P13-030',
      title: 'Zijn opvliegers gevaarlijk voor je gezondheid? ',
      type: 'feedbackQuestion',
      feedbackAnswers: [
        {
          title: 'Ja',
          feedback: `<h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Dat klopt niet.</h2><p style="margin-top: 0;"> Nee, opvliegers zelf zijn niet gevaarlijk voor je gezondheid.</p>
              <p>Door opvliegers kun je wel slecht slapen of stress krijgen. En stress kan wel slecht zijn voor je hart of bloedvaten.</p>`,
          correctOption: false,
        },
        {
          title: 'Nee',
          feedback: `
            <h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Dat klopt.</h2>
            <p style="margin-top: 0;">Opvliegers zelf zijn niet gevaarlijk voor je gezondheid.</p>

            <p>Door opvliegers kun je wel slecht slapen of stress krijgen. En stress kan wel slecht zijn voor je hart of bloedvaten.</p>
          `,
          correctOption: true,
        },
      ],
      button: 'Ga verder',
    },
    {
      path: '/stap-3/vraag-2',
      routeId: 'P13-030',
      nextRouteId: 'P13-031',
      title: 'Is een behandeling met hormonen slecht voor je lichaam?',
      type: 'feedbackQuestion',
      feedbackAnswers: [
        {
          title: 'Ja',
          feedback: `<h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Dit is niet het goede antwoord.</h2>
            <p style="margin-top: 0;">Hormonen gebruiken is niet slecht voor je als je klachten hebt door minder vrouwelijk hormoon. Het maakt klachten zoals opvliegers minder. Ook heb je een kleinere kans op botontkalking. </br>
              Heb je geen klachten door minder vrouwelijk hormoon? Dan hoef je ook geen hormonen te gebruiken.</br>
              Gezond leven blijft het belangrijkst tegen ziektes van hart en bloedvaten en botontkalking.
            </p>
          `,
          correctOption: false,
        },
        {
          title: 'Nee',
          feedback: `<h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Dit is het goede antwoord.</h2>
            <p style="margin-top: 0;">Hormonen gebruiken is niet slecht voor je als je klachten hebt door minder vrouwelijk hormoon. Het maakt klachten zoals opvliegers minder. Ook heb je een kleinere kans op botontkalking. </br>
              Heb je geen klachten door minder vrouwelijk hormoon? Dan hoef je ook geen hormonen te gebruiken.</br>
              Gezond leven blijft het belangrijkst tegen ziektes van hart en bloedvaten en botontkalking.
            </p>
          `,
          correctOption: true,
        },
      ],
      button: 'Ga verder',
    },
    {
      path: '/stap-3/vraag-3',
      routeId: 'P13-031',
      nextRouteId: 'P13-032',
      title: 'Geven hormonen voor opvliegers een grotere kans op borstkanker?',
      type: 'feedbackQuestion',
      feedbackAnswers: [
        {
          title: 'Ja',
          feedback: `
            <h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Ja, dat kan soms zo zijn</h2>
            <p>Niet alle hormonen geven een grotere kans op borstkanker. De kans verschilt per soort progestageen. Hoe lang je het gebruikt heeft er ook invloed op.</p>

            <ul>
              <li><h3 style="font-size: 18px; line-height: 1.6; margin: 0;">Estradiol en dydrogesteron</h3>
                <p style="margin: 0;">Je hebt waarschijnlijk geen grotere kans op borstkanker als je het korter dan 5 jaar gebruikt. Als je het langer gebruikt, heb je een iets grotere kans op borstkanker.</p> </li>
              <li><h3 style="font-size: 18px; line-height: 1.6; margin: 0;">Estradiol en progesteron</h3>
                <p style="margin: 0;">Je hebt waarschijnlijk geen grotere kans op borstkanker als je de hormonen korter dan 5 jaar gebruikt.</p></li>
              <li><h3 style="font-size: 18px; line-height: 1.6; margin: 0;">Estradiol en de hormoonspiraal (levonorgestrel spiraal)</h3>
                <p style="margin: 0;">Je hebt misschien een iets grotere kans op borstkanker.</p></li>
            </ul>
          `,
          correctOption: true,
        },
        {
          title: 'Nee',
          feedback: `
            <h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Dat klopt niet helemaal.</h2>
            <p>Niet alle hormonen geven een grotere kans op borstkanker. De kans verschilt per soort progestageen. Hoe lang je het gebruikt heeft er ook invloed op.</p>

            <ul>
              <li><h3 style="font-size: 18px; line-height: 1.6; margin: 0;">Estradiol en dydrogesteron</h3>
                <p style="margin: 0;">Je hebt waarschijnlijk geen grotere kans op borstkanker als je het korter dan 5 jaar gebruikt. Als je het langer gebruikt, heb je een iets grotere kans op borstkanker.</p> </li>
              <li><h3 style="font-size: 18px; line-height: 1.6; margin: 0;">Estradiol en progesteron</h3>
                <p style="margin: 0;">Je hebt waarschijnlijk geen grotere kans op borstkanker als je de hormonen korter dan 5 jaar gebruikt.</p></li>
              <li><h3 style="font-size: 18px; line-height: 1.6; margin: 0;">Estradiol en de hormoonspiraal (levonorgestrel spiraal)</h3>
                <p style="margin: 0;">Je hebt misschien een iets grotere kans op borstkanker.</p></li>
            </ul>
          `,
          correctOption: false,
        },
      ],
      button: 'Ga verder',
    },
    {
      path: '/stap-3/vraag-4',
      routeId: 'P13-032',
      nextRouteId: 'P13-033',
      title: 'Kun je door minder alcohol drinken ook minder opvliegers krijgen?',
      type: 'feedbackQuestion',
      feedbackAnswers: [
        {
          title: 'Ja',
          feedback: `
            <h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Dat klopt</h2>
            <p style="margin-top: 0;">Door minder of geen alcohol te drinken kun je minder opvliegers krijgen.</p>`,
          correctOption: true,
        },
        {
          title: 'Nee',
          feedback: `
            <h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Dat klopt niet</h2>
            <p style="margin-top: 0;">Door minder of geen alcohol te drinken kun je minder opvliegers krijgen.</p>
          `,
          correctOption: false,
        },
      ],
      button: 'Ga verder',
    },
    {
      path: '/stap-3/vraag-5',
      routeId: 'P13-033',
      nextRouteId: 'P13-034',
      title: 'Een behandeling met hormonen stelt de overgang alleen maar uit. Is dat waar?',
      type: 'feedbackQuestion',
      feedbackAnswers: [
        {
          title: 'Ja',
          feedback: `
            <h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Nee, dit is niet het goede antwoord</h2>
            <p style="margin-top: 0;">De overgang gaat gewoon verder, ook als je hormonen gebruikt. Hormonen kunnen helpen om tijdens de overgang minder klachten te hebben.</p>
          `,
          correctOption: false,
        },
        {
          title: 'Nee',
          feedback: `
            <h2 style="font-size: 18px; line-height: 1.6; margin-bottom: 0;">Ja, dat is het goede antwoord</h2>
            <p style="margin-top: 0;">De overgang gaat gewoon verder, ook als je hormonen gebruikt. Hormonen kunnen helpen om tijdens de overgang minder klachten te hebben.</p>
          `,
          correctOption: true,
        },
      ],
      button: 'Ga verder',
    },
    {
      path: '/stap-3/vraag-6',
      routeId: 'P13-034',
      nextRouteId: 'P13-035',
      subtitle: 'Stelling',
      title: 'Ik heb elke dag veel opvliegers en ik wil er veel minder hebben',
      type: 'likertScale',
      answers: [
        { title: 'Oneens' },
        { title: 'Een beetje oneens' },
        { title: 'Niet eens, niet oneens' },
        { title: 'Een beetje eens' },
        { title: 'Eens' },
      ],
      button: 'Ga verder',
    },
    {
      path: '/stap-3/vraag-7',
      routeId: 'P13-035',
      nextRouteId: 'P13-036',
      subtitle: 'Stelling',
      title: 'Ik wil geen medicijnen gebruiken, want de overgang is geen ziekte',
      type: 'likertScale',
      answers: [
        { title: 'Oneens' },
        { title: 'Een beetje oneens' },
        { title: 'Niet eens, niet oneens' },
        { title: 'Een beetje eens' },
        { title: 'Eens' },
      ],
      button: 'Ga verder',
    },
    {
      path: '/stap-3/vraag-8',
      routeId: 'P13-036',
      nextRouteId: 'P13-037',
      subtitle: 'Stelling',
      title:
        'Ik wil beter slapen, want ik ben overdag heel moe doordat ik ‘s nachts niet kan slapen door de opvliegers',
      type: 'likertScale',
      answers: [
        { title: 'Oneens' },
        { title: 'Een beetje oneens' },
        { title: 'Niet eens, niet oneens' },
        { title: 'Een beetje eens' },
        { title: 'Eens' },
      ],
      button: 'Ga verder',
    },
    {
      path: '/stap-3/vraag-9',
      routeId: 'P13-037',
      nextRouteId: 'P13-038',
      subtitle: 'Stelling',
      title: 'Ik wil proberen of gesprekken met de praktijkondersteuner mij helpen',
      type: 'likertScale',
      answers: [
        { title: 'Oneens' },
        { title: 'Een beetje oneens' },
        { title: 'Niet eens, niet oneens' },
        { title: 'Een beetje eens' },
        { title: 'Eens' },
      ],
      button: 'Ga verder',
    },
    {
      path: '/stap-3/vraag-10',
      routeId: 'P13-038',
      nextRouteId: 'P13-039',
      type: 'question',
      hideFromOverview: false,
      title: 'Heb je een ziekte of een ziekte gehad waardoor hormonen niet geschikt zijn voor jou?',
      description: 'Klik aan of je 1 of meer van deze ziektes of klachten hebt of hebt gehad:',
      descriptionAlign: 'left',
      questions: [
        {
          type: 'multiple',
          answers: [
            {
              title: 'kanker die groeit door hormonen, zoals borstkanker of baarmoederkanker',
            },
            {
              title: 'een bloedklont in een bloedvat (trombose)',
            },
            {
              title: 'een bloedklont in een bloedvat van de longen (longembolie)',
            },
            {
              title: 'een bloedklont in een bloedvat gehad en je gebruikt nu geen bloedverdunners',
            },
            {
              title: 'hartaanval',
            },
            {
              title: 'beroerte',
            },
            {
              title: 'ziekte van de lever',
            },
            {
              title: 'bloed uit je vagina en je weet niet wat de oorzaak is',
            },
          ],
        },
      ],
      button: 'Ga verder',
    },
    {
      path: '/stap-3/vraag-11',
      routeId: 'P13-039',
      nextRouteId: 'P13-040',
      title: 'Ik zou liever een pleister, gel of spray met hormonen willen dan pillen met hormonen',
      type: 'defaultQuestion',
    },
    {
      path: '/stap-3/vraag-12',
      routeId: 'P13-040',
      nextRouteId: 'P13-041',
      title: 'Ik wil een voorbehoedmiddel gebruiken',
      type: 'defaultQuestion',
    },
    {
      path: '/stap-4',
      routeIndex: '4',
      routeId: 'P13-041',
      nextRouteId: 'P13-042',
      type: 'chapter',
      title: 'Alle behandelingen op een rij',
      subtitle: 'Stap 4',
      description: `
        <p>We hebben alles over de behandelingen op een rij gezet. Voordelen, nadelen, voor wie ze geschikt zijn en hoeveel ze helpen.</p>`,
      image: {
        src: `${process.env.PUBLIC_URL}/img/opvliegers-stap-4.jpg`,
        alt: '',
      },
      button: 'Ga verder',
    },
    {
      path: '/stap-4/bekijk-jouw-keuzekaart',
      routeId: 'P13-042',
      nextRouteId: 'P13-043',
      type: 'explanation',
      title: 'Bekijk jouw keuzekaart',
      align: 'left',
      titleAlign: 'center',
      description: `
        <div>
          <p>Een keuzekaart is een overzicht van de behandelingen. Je kunt hiermee behandelingen met elkaar vergelijken.</p>

          <p>Klik hieronder aan welke keuzekaart je wilt downloaden:</p>

          <ul>
            <li><a href="https://www.thuisarts.nl/file/2794/download?token=eJExm0Dx">Als je nog ongesteld bent en ook een voorbehoedmiddel wilt (pdf. 12Mb)</a></li>
            <li><a href="https://www.thuisarts.nl/file/2796/download?token=6sKufW9W">Als je nog ongesteld bent en geen voorbehoedmiddel wilt (pdf. 12Mb)</a></li>
            <li><a href="https://www.thuisarts.nl/file/2798/download?token=STwgxuwP">Als je al een jaar niet meer ongesteld bent (pdf. 12Mb)</a></li>
          </ul>
        </div>
      `,
      button: 'Klaar met lezen, naar de volgende stap',
    },
    {
      path: '/stap-4/vraag-1',
      routeId: 'P13-043',
      nextRouteId: 'P13-044',
      type: 'question',
      title: 'Welke behandeling wil je proberen?',
      description:
        'Nu je deze keuzehulp hebt gedaan: Wil je een behandeling voor opvliegers proberen? Zo ja, welke? Heb je nog vragen aan je arts?',
      descriptionAlign: 'left',
      subtitle: 'Vraag',
      questions: [
        {
          placeholder: 'Vul hier je antwoord in',
          type: 'textarea',
        },
      ],
      button: 'Volgende',
    },
    {
      path: '/print-overview',
      routeIndex: '5',
      routeId: 'P13-044',
      nextRouteId: 'end',
      type: 'end',
      header: {
        title: 'Alsjeblieft, je antwoorden bij deze keuzehulp',
        description: `
          <div>
            <p>Je bent klaar met de keuzehulp. Bespreek met je arts hoe je nu denkt over behandelingen bij opvliegers. En welke behandeling je wilt proberen.</p>

            <p>Heb je nog vragen? Kijk dan op Thuisarts.nl bij <a href="https://www.thuisarts.nl/overgang" target="_blank">Overgang</a>. Of stel ze aan je arts.</p>
          </div>
        `,
      },
    },
  ],
}

export default opvliegers
